import { AssetType } from 'config/consts';
import React from 'react';
import {
  AboutExchangeRateModalButton,
  AssetOrganizedPortfolioProps,
} from './PortfolioStuffingAsset';
import { AssetOrganizedPortfolioItem } from './AssetOrganizedPortfolioItem';
import { AssetOrganizedPortfolioContainer } from './AssetOrganizedPortfolioContainer';

export const AssetOrganizedPortfolio = ({
  assetTypeKey,
  items,
}: AssetOrganizedPortfolioProps): React.ReactElement => {
  return (
    <>
      <AssetOrganizedPortfolioContainer
        {...{
          assetTypeKey,
          SubInformation: () => {
            if (
              assetTypeKey === AssetType['ロボアドバイザー'] ||
              assetTypeKey === AssetType['預金_MRF'] ||
              assetTypeKey === AssetType['外国株式']
            ) {
              return (
                <div className="flex ml-auto">
                  <AboutExchangeRateModalButton isShowMessage />
                </div>
              );
            }
            return <></>;
          },
        }}>
        {items.map((item, i) => {
          return (
            <AssetOrganizedPortfolioItem
              {...item}
              key={i}
              assetTypeKey={assetTypeKey}
            />
          );
        })}
      </AssetOrganizedPortfolioContainer>
    </>
  );
};
